/* eslint-disable no-console */
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { generateToken } from '/src/features/login/api/login-service.js';
import { store } from '../store/index.js';

export async function initAppInsights($axios) {
  const getUserContext = () => {
    const userDetails = store.getters.userDetails;
    return {
      ...(userDetails?.Name && { username: userDetails.Name }),
      ...(userDetails?.client && { clientName: userDetails.client }),
      pageUrl: window.location.href
    };
  };

  try {
    if (!(await generateToken())) {
      return;
    }
    const APPLICATIONINSIGHTS_CONNECTION_STRING_FRONTEND = await $axios.get('/app-insights-string', { timeout: 10000 });
    if (APPLICATIONINSIGHTS_CONNECTION_STRING_FRONTEND) {
      const appInsights = new ApplicationInsights({
        config: {
          connectionString: APPLICATIONINSIGHTS_CONNECTION_STRING_FRONTEND,
          autoExceptionInstrumented: true,
          disableAjaxTracking: false,
          disableFetchTracking: false
        }
      });
      window.appInsights = appInsights;
      appInsights.loadAppInsights();

      appInsights.addTelemetryInitializer((envelope) => {
        const baseType = envelope.baseType;
        const data = envelope.baseData;

        data.properties = {
          ...(data.properties || {}),
          appSource: 'frontendClient',
          ...getUserContext()
        };

        if (baseType === 'RemoteDependencyData') {
          const code = data.responseCode;
          const durationMs = data.duration;

          if (code < 400 && durationMs < 15000) {
            return false;
          }
        }
        return true;
      });

      // --- Forward console.error to App Insights ---
      const originalConsoleError = console.error;
      console.error = function (...args) {
        // Add log to traces
        window.appInsights?.trackTrace(
          {
            message: args.map((a) => (a instanceof Error ? a.stack || a.message : JSON.stringify(a))).join(' '),
            severityLevel: 3
          },
          { type: 'consoleError', appSource: 'frontendClient', ...getUserContext() }
        );
        originalConsoleError.apply(console, args);
      };

      // --- Capture unhandled promise rejections ---
      window.addEventListener('unhandledrejection', (event) => {
        appInsights.trackException({
          exception: event.reason,
          properties: { appSource: 'frontendClient', ...getUserContext() }
        });
      });
    }
  } catch (e) {
    console.log('AppInsights init failed:', e);
    window.appInsights?.trackException({
      exception: e,
      properties: { appSource: 'frontendClient', ...getUserContext() }
    });
  }
}

export default defineNuxtPlugin(({ vueApp }) => {
  window.appInsights = {
    trackException: () => {},
    trackTrace: () => {},
    trackDependencyData: () => {}
  };
  const $axios = vueApp.$axios;
  initAppInsights($axios);
});
